export default __webpack_public_path__ + "static/media/BRS-CIRCLE.c4fb81c2.png";